import PropTypes from 'prop-types';

// Bilingual label coming back from the backend metadata payload.
export const localizedTextShape = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    vi: PropTypes.string,
    en: PropTypes.string,
    code: PropTypes.string,
  }),
]);

// A single candidate row from /breakout/candidates.
export const candidateRowShape = PropTypes.shape({
  ticker: PropTypes.string,
  company_name: PropTypes.string,
  sector: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  signal: PropTypes.string,
  signal_label: localizedTextShape,
  ai_confidence: PropTypes.any, // eslint-disable-line react/forbid-prop-types
  breakout_score: PropTypes.number,
  score_date: PropTypes.string,
  trade_plan: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  market_regime: PropTypes.string,
  market_regime_label: localizedTextShape,
  trigger_type: PropTypes.string,
  trigger_type_label: localizedTextShape,
  reasons: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  components: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  sector_metrics: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  price: PropTypes.shape({
    close: PropTypes.number,
    dist_from_resistance: PropTypes.number,
    resistance_20d: PropTypes.number,
  }),
  smart_money: PropTypes.shape({
    up_value_ratio: PropTypes.number,
    accumulation_days_10: PropTypes.number,
    support_hold_count: PropTypes.number,
  }),
  liquidity: PropTypes.shape({
    avg_value_20d: PropTypes.number,
    value_ratio: PropTypes.number,
  }),
  strength: PropTypes.shape({
    strength_tier: PropTypes.string,
    strength_tier_label: localizedTextShape,
    strength_score: PropTypes.number,
    relative_strength_score: PropTypes.number,
    risk_penalty_score: PropTypes.number,
  }),
});

// Output of `tierStyle()`; used by table tail cells.
export const tierTagShape = PropTypes.shape({
  bg: PropTypes.string,
  fg: PropTypes.string,
});

// Filter form state managed in the page container.
export const breakoutFiltersShape = PropTypes.shape({
  preset: PropTypes.string,
  min_score: PropTypes.number,
  signal: PropTypes.string,
  market_regime: PropTypes.string,
  strong_only: PropTypes.bool,
  exclude_trigger_none: PropTypes.bool,
  limit: PropTypes.number,
});

// Aggregated summary stats computed from candidate list.
export const breakoutStatsShape = PropTypes.shape({
  buy: PropTypes.number,
  watch: PropTypes.number,
  avg: PropTypes.number,
  max: PropTypes.number,
  topSector: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  regimeCount: PropTypes.object, // eslint-disable-line react/forbid-prop-types
});

// One row in the per-ticker signal history series.
export const signalHistoryPointShape = PropTypes.shape({
  score_date: PropTypes.string,
  breakout_score: PropTypes.number,
  signal: PropTypes.string,
  trigger_type: PropTypes.string,
});

// Ref prop type accepted by drawer/body wrapper Box elements.
export const refShape = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.any }),
]);
